import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const ITEMS = ['Sos fonoaudióloga psicopedagoga o neurolingüista', 'Trabajás con pacientes que tartamudean tienen disfluencia o disfemia', 'Llegás a casa y todavía tenés que preparar material para mañana', 'Necesitás fichas distintas para un nene de 6 y un adulto de 35 y no tenés tiempo de crear dos sistemas', 'La familia te pregunta si hay progreso y no tenés cómo mostrárselo', 'Querés coordinar con el colegio pero no tenés el material para hacerlo de manera profesional', 'Querés que tu consultorio funcione como el de una especialista que sabe exactamente lo que hace'];
export function Checklist() {
  return <section className="flex flex-col gap-8 py-12" data-id="element-30">
      <h3 className="font-serif text-3xl font-bold text-[#0F4C3A] text-center" data-id="element-31">
        Este sistema es para vos si…
      </h3>

      <div className="flex flex-col gap-4" data-id="element-32">
        {ITEMS.map((item, idx) => <div key={idx} className="flex flex-col bg-white p-5 rounded-xl shadow-sm border border-stone-200 gap-3 items-center text-center" data-id="element-33">
            <CheckCircle2 className="text-[#D97757] w-8 h-8 flex-shrink-0" data-id="element-34" />
            <p className="text-lg text-stone-800 font-medium" data-id="element-35">{item}</p>
          </div>)}
      </div>
    </section>;
}